import { Component } from '@angular/core';

@Component({
    selector: 'view-child-communication-event',
    templateUrl: './view-child-communication-event.component.html',
    styleUrl: './view-child-communication-event.component.scss'
})
export class ViewChildCommunicationEventComponent {}
